import * as React from 'react';
import b_ from 'b_';
import Tooltip from 'shared/components/Tooltip';
import MoneyView from 'shared/components/MoneyView';
import { Money } from 'types/common';

import './index.scss';

interface Props {
  fees: React.ReactNode;
  totalFeeAmount: Money | null;
}

const b = b_.with('position-details-fees');

export const TotalFee: React.FC<Props> = ({ totalFeeAmount, fees }) => {
  if (!totalFeeAmount) {
    return <span data-testid="total-fee">0</span>;
  }
  return (
    <div className={b()} data-testid="total-fee">
      <Tooltip
        placement="bottom"
        trigger={['click']}
        overlay={<div className="rc-overlay">{fees}</div>}
      >
        <div>
          <MoneyView cents>{totalFeeAmount}</MoneyView>
        </div>
      </Tooltip>
    </div>
  );
};
